import React from 'react';
import Divider from '@material-ui/core/Divider';

const styles = {
  divider: {
    marginTop: 24,
    marginBottom: 24
  }
};

const DialogDivider = () => <Divider style={styles.divider} variant='inset' />

export default DialogDivider;